module.exports = __webpack_public_path__ + "media/images/flags/64/Senegal-adbcaee92d966b7dec6b1b8205a5bd2e.png";